import { Ability, AbilityBuilder, AbilityClass } from '@casl/ability'
import { IUser } from 'redux/store/user/types'
import { ACTIONS, SUBJECTS } from '../Abilities/constants'
import {
  MyOrganizationCommunityAbilityBuilder,
  MyOrganizationCommunityAbility,
  PossibleAbilities,
  Conditions
} from './types'
import { ROLES } from 'features/Permission'
import { HOSPITAL_STATUSES } from 'constants/common'
import { MOOV_BUSINESS_ACCOUNT_STATUS } from '../../BankingSetupCommunity/constants'

const MyOrganizationAbilityClass =
  Ability as AbilityClass<MyOrganizationCommunityAbility>

export const ability = new Ability<PossibleAbilities, Conditions>()

export default (user: IUser) => {
  const builder = new AbilityBuilder(MyOrganizationAbilityClass)

  switch (user.role) {
    case ROLES.VICE_PRESIDENT:
    case ROLES.COMMUNITY_PRESIDENT:
    case ROLES.HOSPITAL_ADMIN:
    case ROLES.FINANCE:
      defineCommunityAbilities(builder, user)
      break
  }

  return new Ability(builder.rules) as MyOrganizationCommunityAbility
}

const defineCommunityAbilities = (
  builder: MyOrganizationCommunityAbilityBuilder,
  user: IUser
) => {
  const isHSOwnerCondition = {
    uuid: user.health_system
  }
  const isHospitalOwnerCondition = {
    uuid: user.hospital
  }

  const isHospitalActiveCondition = {
    status: HOSPITAL_STATUSES.ACTIVE
  }

  const isBusinessAccountVerifiedCondition = {
    businessAccountStatus: MOOV_BUSINESS_ACCOUNT_STATUS.VERIFIED
  }

  if (user.role === ROLES.FINANCE) {
    builder.can(
      ACTIONS.VIEW,
      SUBJECTS.BANKING_SETUP_HS_DETAILS,
      isHSOwnerCondition
    )
    builder.can(ACTIONS.VIEW, SUBJECTS.BANKING_SETUP_HOSPITAL_DETAILS)
    builder.can(
      ACTIONS.VIEW,
      SUBJECTS.BANK_ACCOUNTS_HOSPITAL_DETAILS,
      isBusinessAccountVerifiedCondition
    )
    builder.can(ACTIONS.VIEW, SUBJECTS.BANK_ACCOUNTS_HS_DETAILS, {
      ...isHSOwnerCondition,
      ...isBusinessAccountVerifiedCondition
    })
  }

  if (user.role === ROLES.VICE_PRESIDENT) {
    builder.can(
      ACTIONS.VIEW,
      SUBJECTS.BANKING_SETUP_HS_DETAILS,
      isHSOwnerCondition
    )
    builder.can(ACTIONS.VIEW, SUBJECTS.BANK_ACCOUNTS_HS_DETAILS, {
      ...isHSOwnerCondition,
      ...isBusinessAccountVerifiedCondition
    })
  }

  if (user.role === ROLES.HOSPITAL_ADMIN) {
    builder.can(ACTIONS.VIEW, SUBJECTS.BANKING_SETUP_HOSPITAL_DETAILS, {
      ...isHospitalOwnerCondition,
      ...isHospitalActiveCondition
    })
    builder.can(ACTIONS.VIEW, SUBJECTS.BANK_ACCOUNTS_HOSPITAL_DETAILS, {
      ...isHospitalOwnerCondition,
      ...isHospitalActiveCondition,
      ...isBusinessAccountVerifiedCondition
    })
  }
}
